import get from 'lodash/get';

import {
  CLEAR_INVITE_INFO,
  GET_INVITE_INFO_SUCCESS,
  GET_VISITORS_SUCCEEDED,
  GET_VISITOR_INFO_BY_CREATOR_ID_SUCCESS,
  GET_VISITOR_INFO_BY_ID_SUCCESS,
  SET_NEW_VISITOR_SUCCEEDED,
  UPDATE_NEW_VISITOR_SUCCEEDED,
} from '../actionConstants';

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_VISITORS_SUCCEEDED:
      return get(action, 'res.data');
    case SET_NEW_VISITOR_SUCCEEDED:
    case UPDATE_NEW_VISITOR_SUCCEEDED:
      return {
        ...state,
        completeData: {},
      };
    case GET_INVITE_INFO_SUCCESS:
      return {
        ...state,
        inviteInfo: { ...get(action, 'res.data') },
      };
    case CLEAR_INVITE_INFO:
      return {
        ...state,
        inviteInfo: {},
      };

    case GET_VISITOR_INFO_BY_ID_SUCCESS:
      return {
        [action.visitorId]: action.res && action.res.data,
      };
    case GET_VISITOR_INFO_BY_CREATOR_ID_SUCCESS:
      return {
        ...state,
        visitorsInfo: { ...get(action, 'res.data') },
      };
    case '@@router/LOCATION_CHANGE':
      return defaultState;
    default:
      return state;
  }
};
